import { Link } from 'react-router-dom';
import type { Title } from '@/mocks/titles';
import RatingBadge from '@/components/base/RatingBadge';
import { TypeTag } from '@/components/feature/TitleCard';

export default function TitleRow({ item }: { item: Title }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      title={`${item.title} - ${item.genres.join('/')}`}
    >
      <div className="w-24 sm:w-28 md:w-32 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} ${item.type === 'movie' ? '电影' : '电视剧'}在线观看`}
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <RatingBadge rating={item.rating} size="sm" />
        </div>

        <div className="flex flex-wrap items-center gap-2 mt-2 text-xs text-foreground-600">
          <TypeTag type={item.type} />
          <span>{item.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.region}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.genres.join(' / ')}</span>
          {item.type === 'tv' && item.status && (
            <span
              className={`rounded-md px-1.5 py-0.5 ${
                item.status === 'ongoing' ? 'bg-accent-100 text-accent-800' : 'bg-secondary-100 text-secondary-900'
              }`}
            >
              {item.status === 'ongoing' ? `连载至${item.episodes}集` : '已完结'}
            </span>
          )}
        </div>

        <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {item.synopsis}
        </p>

        <div className="mt-auto pt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-star-line"></i>导演：{item.director}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-team-line"></i>主演：{item.cast.slice(0, 3).join('、')}
          </span>
          {item.type === 'tv' && (
            <span className="flex items-center gap-1">
              <i className="ri-refresh-line"></i>更新：{item.updatedAt}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}